export default "__VITE_ASSET__Oo6Dpbaf__"